<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <!-- <div class="beiAn">
      <span v-show="isShow == 1">
        {{ banquan
        }}<a href="https://beian.miit.gov.cn" target="_blank">{{ beian }}</a>
      </span>

      <span v-show="isShow == 2">
        {{ underCompanyName }}
      </span>

      <span v-show="isShow == 3">

      </span>
    </div> -->
    <!-- 
    <div class="splash-screen">
      <img src="./assets/img/img.png" alt="Logo" style="width: 100%;">
    </div> -->


  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      banquan: "",
      beian: "",
      underCompanyName: "",
      isShow: '',
    };
  },
  mounted() {
    // 最顶部
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });


    this.banquan = banquan;
    this.underCompanyName = underCompanyName;
    this.beian = beian;
    // 判断时间显示底部备案信息
    if (this.$route.path == '/verification') {
      if (date > this.getNowDate()) {
        this.isShow = 2;
      } else {
        this.isShow = 3;
      }
    } else if (this.$route.path == '/outReport') {
      this.isShow = 3;
    }
    else {
      this.isShow = 1;
    }

    let path = this.$route.fullPath;
    // let path = 'https://www.kunuocloud.com/index.html?need_out_animation=4&finish_when_network_unavailable=false&from_im=true&disable_auto_expose=1&font_scale=1.0#/wscAZAX&bdx_monitor_append_params=%7B%22enter_from%22%3A%22im'
    let arr = path.split('/');
    // console.log(this.$route)
    let strWsc;
    if (path.indexOf('wsc') != -1) {
      arr.map((i, q) => {
        if (i.indexOf('wsc') != -1) {
          strWsc = i
        }
      })
      let arr2 = strWsc.split('&');
      arr2.map((i, q) => {
        if (i.indexOf('wsc') != -1) {
          let par = i.substr(3, 12)
          this.$router.push({
            name: 'wsc',
            params: { id: par }
          });
        }
      })
    }




    this.waitForLoad();
  },
  methods: {

    waitForLoad() {
      // 检测你的应用或资源是否已加载完成
      setTimeout(() => {
        // 假设10秒后移除启动页
        document.body.classList.add('loaded');
      }, 2000);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = (year * 10000) + (month * 100) + day;
      return NOW_MONTHS_AGO
    }


  },
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
  position: relative;
}

.beiAn {
  width: 400px;
  position: absolute;
  bottom: 5px;
  left: 50%;
  margin-left: -200px;
  text-align: center;
  color: #bbb;
  font-size: 16px;
}

a {
  color: #bbb;
  text-decoration: none;
}




.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  z-index: 9999;
}


.loaded .splash-screen {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue